import { TInitialState } from '~/src/features/tariffBuilder/reducer';

import { hasSelectedEquipment } from './hasSelectedEquipment';

/**
 * Select data for final page
 */
export const selectFinalData = (state: TInitialState) => {
    return {
        agreementData: {
            isDouble: state.agreement.isDouble,
            hasError: state.agreement.hasError,
        },
        hasEquipment: hasSelectedEquipment(state),
        slot: state.selectedTimeSlot,
    };
};
